import styled from '@emotion/styled';
import { gettext } from '@eventbrite/i18n';
import { Badge, Typography } from '@eventbrite/marmalade';
import { format } from 'date-fns';
import React from 'react';
import { useTransientAutoCreatedEventContext } from '../../../DraftEventStoreProvider';

export enum EventDescriptionTestId {
    Container = 'EventDescriptionContainer',
}

export const EventDescription = () => {
    const badgeProps = {
        children: (
            <Typography as="p" color="neutral-1000" variant="body-md-bold">
                {gettext('Just Added!')}
            </Typography>
        ),
        variant: 'custom',
        bordered: false,
    };

    const style = {
        background: '#EDE9F5',
        backgroundColor: '#cddfd6',
        width: 'fit-content',
    };

    const { transientAutoCreatedEvent } = useTransientAutoCreatedEventContext();

    if (!transientAutoCreatedEvent) return null;

    return (
        <EventDescriptionContainer
            aria-label="Information about the event"
            data-testid={EventDescriptionTestId.Container}
        >
            <Badge {...badgeProps} style={style} />
            <DateAndTitleContainer>
                <Typography as="p" color="ui-800" variant="body-lg">
                    {format(
                        new Date(transientAutoCreatedEvent.start.utc),
                        'EE, MMMM d',
                    )}
                </Typography>
                <Typography as="h2" color="neutral-900" variant="heading-lg">
                    {transientAutoCreatedEvent.name.html}
                </Typography>
            </DateAndTitleContainer>
            <Typography as="p" color="neutral-1000" variant="body-md">
                {transientAutoCreatedEvent.summary}
            </Typography>
        </EventDescriptionContainer>
    );
};

const EventDescriptionContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const DateAndTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;
